import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchRegistrationQuestions } from '@/store/slices/channel';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { useEffect, useRef } from 'react';

const useLoadRegistrationQuestions = () => {
  const channel = useAppSelector(getActiveChannel);

  const dispatch = useAppDispatch();

  const fetched = useRef(false);

  useEffect(() => {
    if (!channel || fetched.current) return;
    fetched.current = true;
    dispatch(fetchRegistrationQuestions({ channel }));
  }, [channel, dispatch]);
};

export default useLoadRegistrationQuestions;
